import React from 'react';
import { cn } from '@/lib/utils';

export const RIQUE_ICON_SRC = '/rique-icon.png';

export interface RiqueIconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  className?: string;
}

/** Avatar do assistente Rique.Ia (ilustração do menino). */
export const RiqueIcon: React.FC<RiqueIconProps> = ({ className, alt = '', ...props }) => (
  <img
    src={RIQUE_ICON_SRC}
    alt={alt}
    aria-hidden={alt === '' ? true : undefined}
    draggable={false}
    className={cn('object-contain', className)}
    {...props}
  />
);
